export type IResetCropImageModal = (modal: IjQueryElmOrHtmlElm) => void;

export function _resetCropImageModal(modal: IjQueryElmOrHtmlElm): void {
  // Modal Elements
  const $modal = $(modal);
  const $modalTitle = $modal.find('.modal-custom-title');
  const $modalImgElm = $modal.find('.modal-body .full-image');
  const $modalLoading = $modal.find('.loading');
  const $imageContainer = $modal.find('.image-container');
  const $cropperContainer = $modal.find('.cropper-container');
  // Empty elements
  $cropperContainer.empty().remove();
  $modalTitle.html('');
  $modalLoading.removeClass('hide').attr('aria-hidden', 'false');
  $imageContainer.addClass('hide').attr('aria-hidden', 'true');
  ($modalImgElm as any).cropper('destroy');
  $modalImgElm.attr({
    alt: '',
    src: '',
  });
}
